import {api, getApiError, handleApiError, ServiceResponse} from "../ApiClient";

export interface PrepaidBagProductResource {
    name: string

    quantity: number
    clubId: string
    currency: string
    discount: number
    totalFee: number
    displayPrice: string
}

export interface PrepaidBagProduct extends PrepaidBagProductResource {
    id: string
}

export interface PrepaidBagProductResponse extends ServiceResponse{
    product?: PrepaidBagProduct
}

export interface PrepaidBagProductsResponse extends ServiceResponse {
    products?: PrepaidBagProduct[]
}

export interface Purchase {
    productId: string
    productType: string
    status: string
}

export interface PurchaseResponse extends ServiceResponse {
    purchase?: Purchase
}

export const PrepaidBagProductService = () => {

    const get = (productId: string): Promise<PrepaidBagProductResponse> => {
        return api.get<PrepaidBagProduct>(`/api/1/pre-paid-bags/${productId}`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        product: resp.data
                    }
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    };

    const getAll = (clubId: string): Promise<PrepaidBagProductsResponse> => {
        return api.get<PrepaidBagProduct[]>(`/api/1/pre-paid-bags?clubId=${clubId}`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        products: resp.data
                    }
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    };

    const buy = (productId: string): Promise<ServiceResponse> => {
        const source = window.location.host.includes("staging-caddies") ? "CADDIES_WEB_STG" : "CADDIES_WEB_PROD";
        return api.post<{ url: string }>(`/api/1/purchases`, {
            productType: 'PREPAID_BAGS',
            productId: productId,
            source: source
        })
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    window.location.href = resp.data.url
                    return {};
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    };

    const getAndRectify = (purchaseId: string): Promise<PurchaseResponse> => {
        return api.get<Purchase>(`/api/1/purchases/${purchaseId}?rectify=true`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        purchase: resp.data
                    };
                }

                let e = getApiError(resp)
                return {
                    error: {
                        apiError: e,
                        message: e.message ? e.message : "Unknown error occurred."
                    }
                }
            })
            .catch(handleApiError)
    };

    return {
        getPrepaidBagProduct: get,
        getAllPrepaidBagProductsForClub: getAll,
        buyPrepaidBagProduct: buy,
        getAndRectifyPurchase: getAndRectify
    }
}
